const productVariantIds = {
  monthly: {
    saga1: 46060371017986,
    saga2: 44099353444610,
    saga3: 44103507345666,
    saga4: 44103507575042,
  },
  annual: {
    saga1: 46054529499394,
    saga2: 44099388145922,
    saga3: 44099388473602,
    saga4: 44103595852034,
  },
};
const sellingPlanIds = {
  monthlySellingPlanId: 3010134274,
  annualSellingPlanId: 3010167042,
  monthlyWShipping: 3039756546,
  annualWShipping: 3039756546,
};

const updateCartDrawer2 = (sections) => {
  let cartDrawerEl = document.querySelector("#CartDrawer");
  let html = new DOMParser()
    .parseFromString(sections["cart-drawer"], "text/html")
    .querySelector("#CartDrawer").innerHTML;
  cartDrawerEl.innerHTML = html;
  let bubbleEl = document.querySelector("#cart-icon-bubble");
  bubbleEl.innerHTML = sections["cart-icon-bubble"];
};

$(".fibc-product__plan-block").click((e) => {
  var blockContainer = e.currentTarget.parentElement;
  var openElement = $(".fibc-product__info-open");

  if (!blockContainer.classList.contains("fibc-product__info-open")) {
    $(".fibc-product__info-open .fibc__plan-select").removeAttr("ischecked");
    openElement.removeClass("fibc-product__info-open");
    blockContainer.classList.add("fibc-product__info-open");
    $(".fibc-product__info-open .fibc__plan-select").click();
    $(".fibc-product__info-open .fibc__plan-select").attr("ischecked", "true");

    const sagaSelectEl = document.querySelector(".fibc-saga-select__options");
  }
});

const addItemsToCart = (formData, buttonEl, discount) => {
  let customOrderTag = buttonEl.target.getAttribute("aria-custom-order-tag");
  if (customOrderTag) {
    formData.items[formData.items.length - 1].properties._custom_order_tag =
      customOrderTag;
    if (customOrderTag.includes("FMF"))
      formData.items[formData.items.length - 1].properties._move_to_S1B1 =
        "Move to S1B1";
  }
  $.ajax({
    type: "POST",
    url: "/cart/add",
    dataType: "json",
    data: formData,
    success: async function (res) {
      buttonEl.target.innerHTML = "Added";
      if (discount) {
        window.location.href = `/discount/${discount}?redirect=/checkout`;
      } else {
        updateCartDrawer2(res.sections);
        setTimeout(() => {
          document
            .querySelector("#cartDrawerContainer")
            .classList.add("active");
        }, 500);
        buttonEl.target.removeAttribute("disabled", "");
      }
    },
  }).fail(function (e) {
    return window.location.reload(), !1;
  });
};

const customSagaSelect = (e) => {
  let optionsEl = document.querySelector(".fibc-saga-select__options");
  if (optionsEl) {
    let sagaValue = optionsEl.value,
      planSelect = optionsEl.getAttribute("aria-plan-select"),
      vid = productVariantIds[planSelect][sagaValue];
    e.items[e.items.length - 1].id = vid;
  }
  return e;
};

const getFreeProductData = async (e) => {
  let t = e.getAttribute("freeBookHandle"),
    a,
    r;
  if (t) {
    try {
      await $.getJSON(
        window.Shopify.routes.root + "products/" + t + ".js",
        function (e) {
          (a = e.variants[0].id), (r = e.variants[0].sku);
        }
      );
    } catch (o) {
      console.log(o);
    }
    return { freeBookVid: a, freeBookSku: r };
  } else {
    return false;
  }
};

const setFormData = (formData, variantId, sellingPlan, tag) => {
  formData.items.push({
    quantity: 1,
    id: variantId,
    form_type: "product",
  });
  if (sellingPlan)
    formData.items[formData.items.length - 1].selling_plan = sellingPlan;
  if (tag)
    formData.items[formData.items.length - 1].properties = {
      _free_book_vid: tag,
    };
};

var fibcAtcElements = document.getElementsByClassName(
  "fibc-product__atc-submit"
);
for (i = 0; i <= fibcAtcElements.length - 1; i++) {
  fibcAtcElements[i].addEventListener("click", async (e) => {
    // Change button text
    e.target.innerHTML = "adding...";
    e.target.setAttribute("disabled", "");

    let selectedEl = document.querySelector(
      ".fibc__plan-select[ischecked='true']"
    );
    let subId = parseInt(selectedEl.value);
    let freeProduct = await getFreeProductData(selectedEl);

    let formData = {
      items: [],
      sections: "cart-drawer,cart-icon-bubble",
    };
    // The free product that comes with monthly and annual
    if (freeProduct)
      setFormData(formData, freeProduct.freeBookVid, "", freeProduct.freeBookSku);
    // Another free book for pages that offer 2 free books
    if (selectedEl.dataset.freeBook)
      setFormData(formData, selectedEl.dataset.freeBook);
    switch (subId) {
      case 46060371017986:
        // Monthly sub
        setFormData(formData, subId, sellingPlanIds.monthlySellingPlanId);
        break;
      case 46054529499394:
        // Surprise book
        if (selectedEl.dataset.annualBook)
          setFormData(formData, selectedEl.dataset.annualBook);
        // Annual sub
        setFormData(formData, subId, sellingPlanIds.annualSellingPlanId);
    }
    
    if (e.target.dataset.toCheckout == "true") {
      addItemsToCart((formData = customSagaSelect(formData)), e, e.target.dataset.toCheckout);
    } else {
      addItemsToCart((formData = customSagaSelect(formData)), e, "");
    }
  });
}

const checkForFreeBook = async (e, t) => {
  let a = e.getAttribute("freeBookHandle");
  if (a) {
    let r, o;
    try {
      await $.getJSON(
        window.Shopify.routes.root + "products/" + a + ".js",
        function (e) {
          (r = e.variants[0].id), (o = e.variants[0].sku);
        }
      );
    } catch (c) {
      console.log(c);
    }
    (t.items[0].properties = { _free_book_vid: o }),
      t.items.push({ quantity: 1, id: r, form_type: "product" });
  }
  return t;
};

for (
  var fibcMonthlyAtcElements =
      document.getElementsByClassName("fibc-monthly-atc"),
    i = 0;
  i <= fibcMonthlyAtcElements.length - 1;
  i++
)
  fibcMonthlyAtcElements[i].addEventListener("click", async (e) => {
    (e.target.innerHTML = "adding..."),
      e.target.setAttribute("disabled", ""),
      radioBtn &&
        "yes" == radioBtn.attr("isChecked") &&
        upsellListItem(onPageUpsellVid, onPageUpsellLineProperty);
    let selectedPlan = document.querySelector(".fibc__plan-select[checked]"),
      formData = {
        items: [
          {
            quantity: 1,
            id: selectedPlan.value,
            selling_plan: sellingPlanIds.monthlySellingPlanId,
            form_type: "product",
          },
        ],
        sections: "cart-drawer,cart-icon-bubble",
      };
    addItemsToCart(
      (formData = customSagaSelect(
        (formData = await checkForFreeBook(selectedPlan, formData))
      )),
      e
    );
  });